// extracted by mini-css-extract-plugin
module.exports = {"ourTeamContainer":"OurTeam_ourTeamContainer___LN-z","ourTeamTitle":"OurTeam_ourTeamTitle__lyPVQ"};